export default __webpack_public_path__ + "assets/6story.c07a634a.png";